import { 
  Blog, 
} from '../types/blog';
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const blogsApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getBlogs: build.query<any, void>({
      query: () => ({
        url: appEndpoint.getBlogs,
        method: 'get',
      }),
      providesTags: ['Blogs'],
    }),
    addBlog: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.addBlog,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Blogs"] : []),
    }),

    updateBlog: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.updateBlog}/${data.id}?_method=put`,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Blogs"] : []),
    }),
    getBlogById: build.query<any, string>({
      query: (id) => ({
        url: `${appEndpoint.getBlogs}/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [{ type: 'Blogs', id }],
    }),

    deleteBlog: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.deleteBlog}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Blogs'],
    }),

  }),
  overrideExisting: false,
});

export const {
  useGetBlogsQuery,
  useDeleteBlogMutation,
  useUpdateBlogMutation,
  useAddBlogMutation,
  useGetBlogByIdQuery
} = blogsApi;